export default {"src":"/_next/static/media/filter-icon-orange.de273ab2.svg","height":18,"width":22,"blurWidth":0,"blurHeight":0};